import React from 'react';
import PrivacyPolicyES from './PrivacyPolicyES';
import PrivacyPolicyEN from './PrivacyPolicyEN';
import useLanguage from '../../customHooks/useLanguage';

const SelectPrivacyPolicy = () => {
    const language = useLanguage();

    const translatedCookie = {
        en: <PrivacyPolicyEN />,
        es: <PrivacyPolicyES />,
        fr: <PrivacyPolicyEN />,
        de: <PrivacyPolicyEN />,
    };

    const getTranslatedCookie = _language => {
        return translatedCookie[_language];
    };

    return <div>{getTranslatedCookie(language)}</div>;
};

export default SelectPrivacyPolicy;
